class LogoMarquee {
    constructor(elem) {
        this.elem = elem;
        this.track = this.elem.querySelector(".logo-marquee__rail");

        this.init();
    }

    init() {
        const width = this.track.scrollWidth / 2;

        // pixels per second
        const speed = 100;

        // duration based on distance
        const duration = width / speed;

        this.track.style.animationDuration = `${duration}s`;
    }
}

const logoMarqueeElem = document.querySelector(".logo-marquee");
if (logoMarqueeElem) new LogoMarquee(logoMarqueeElem);
